import React from 'react'

const Loader = () => {
    return (
        <div className='loader-indector'>
            <div className="loader"></div>
        </div>

    )
}

export default Loader
